import React from 'react';

const TwitterIcon = ({ fill = '#fff', className }) => {
    return (
        <svg width={16} height={13} viewBox="0 0 16 13" className={className}>
            <path
                d="M5.032 13c6.095 0 9.537-5.147 9.33-9.763A6.66 6.66 0 0016 1.538a6.554 6.554 0 01-1.885.517A3.285 3.285 0 0015.558.239a6.588 6.588 0 01-2.084.797A3.279 3.279 0 0011.077 0C8.96 0 7.402 1.977 7.88 4.03A9.317 9.317 0 011.114.6 3.285 3.285 0 002.13 4.982a3.268 3.268 0 01-1.487-.41c-.036 1.52 1.054 2.942 2.633 3.26a3.294 3.294 0 01-1.482.055 3.284 3.284 0 003.066 2.28A6.598 6.598 0 010 11.525 9.292 9.292 0 005.032 13z"
                fill={fill}
                fillRule="evenodd"
            />
        </svg>
    );
};

export default TwitterIcon;
